import { setTransition } from '../framework'

export default ref => {
  if (!ref.setTransition) return

  ref.setTransition.forEach(el => {
    el.addEventListener('click', () => setTransition(el.dataset.transition))
  })
}